
import * as React from 'react';
import { Row, Col } from 'antd';
import { TextView } from 'src/core/ui/text.view';
import { RichTextView } from 'src/core/ui/richtextview/text.view.rich';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

interface IUserTaskGroupingExecutorProps {
	onFieldChange: (field: string, value: any) => void;
	values?: { [id: string]: any };
	mode: ControlMode;
}

interface IUserTaskGroupingExecutorState {

}

@observer
export default class UserTaskGroupingExecutor extends React.Component<IUserTaskGroupingExecutorProps, IUserTaskGroupingExecutorState>{

	@observable
	subject: string;

	@observable
	lookahead: string;


	public componentDidMount() {
		if (this.props.values)
		{

			this.subject = this.props.values['subject'];
			this.lookahead = this.props.values['lookahead'];

			this.props.values.validate = () => {
				if (!this.props.values['subject'])
					return { result: false, errors: "The subject is required for this executor. \n" };

				return { result: true, errors: "" };
			}
		}
	}

	render() {

		const { values } = this.props;

		return (<React.Fragment>

			<Row gutter={24}>
				<Col xs={24}>
					<p>The Body field will be rendered using Razor Engine. The injected model will be an instance of an anonymous type with the following structure:
						<br />
						
					</p>
					<p>
						IEnumerable (UserTasksChangeEvent) <strong>PastTasks</strong>
					</p>
					<p>
						IEnumerable (UserTasksChangeEvent) <strong>TodayTasks</strong>
					</p>
					<p>
						IEnumerable (UserTasksChangeEvent) <strong>NextTasks</strong>
					</p>
				</Col>
			</Row>
			<Row gutter={24}>
				<Col xs={5}>
					<TextView
						label='Lookahead days'
						mode={this.props.mode}
						value={this.lookahead}
						onChanged={(e) => {
							this.lookahead = e;
							this.props.onFieldChange("lookahead", e)
						}
						}
					/>

				</Col>
				<Col xs={19}>
					<TextView
						label='Subject'
						mode={this.props.mode}
						value={this.subject}
						onChanged={(e) => {
							this.subject = e;
							this.props.onFieldChange("subject", e)
						}
						}
					/>

				</Col>
			</Row>
			<Row gutter={24}>

				<Col xs={24}>
					<RichTextView
						label='Email template'
						mode={this.props.mode}
						value={values["bodyTemplate"]}
						onChanged={(e) => this.props.onFieldChange("bodyTemplate", e)}
					/>

				</Col>
			</Row>
		</React.Fragment>);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/parts/executors/user-task-grouping.executor.tsx